import mutations from './mergingPatients.mutations'
import actions from './mergingPatients.actions'
import getters from './mergingPatients.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
